import {
  CALL_API,
} from 'redux-api-middleware'

import {
  UPLOAD_IMAGE_COURSE_REQUEST,
  UPLOAD_IMAGE_COURSE_SUCCESS,
  UPLOAD_IMAGE_COURSE_FAILURE,
} from './types'

import { token } from '../utils'
const headers = {
  'x-session-token': token,
  'server-name': 'deknerd',
}

export const uploadCourseImage = (endpoint, img) => {
  const formData = new FormData(img)
  formData.append('course', img)
  formData.append('course_16_9', img)
  formData.append('course_1_1', img)
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'POST',
        body: formData,
        headers,
        types: [
          UPLOAD_IMAGE_COURSE_REQUEST,
          UPLOAD_IMAGE_COURSE_SUCCESS,
          UPLOAD_IMAGE_COURSE_FAILURE,
        ],
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/uploadCourse.js